<template>
  <section>
    <div class="section-header">
      <h2>
        {{ name }}
        <roe-tooltip
          text="Tracks potential issues for Plan Sponsors and Participants. The chart shows the budget for employer match and other contributions for the current year and the next 3 years"
        ></roe-tooltip>
      </h2>
      <div class="btn-wrap">
        <!-- TODO: Remove-->
        <div v-if="selectingYear" class="input-wrap">
          <v-select
            :options="lagIndicatorYears"
            :value="lagIndicatorsSelectedYear"
            @input="setSelectedYear"
          ></v-select>
        </div>
        <div class="tab-buttons-wrap">
          <button
            class="tab-button"
            :class="{ current: chartView }"
            @click="showChart()"
          >
            Chart
          </button>
          <button
            class="tab-button"
            :class="{ current: !chartView }"
            @click="showTable()"
          >
            Table
          </button>
        </div>
      </div>
    </div>
    <div class="section-content">
      <roe-plan-designs-mini-table></roe-plan-designs-mini-table>
      <div class="table-wrap">
        <div class="table">
          <slot name="chartView" v-if="chartView"></slot>
          <slot name="tableView" v-if="!chartView"></slot>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import RoeTooltip from "@/components/_shared/Tooltip";
import { mapGetters, mapMutations } from "vuex";
import { ALTERNATIVE_DESIGNS_SET_LAG_INDICATORS_SELECTED_YEAR } from "@/store/mutations.type";
import RoePlanDesignsMiniTable from "@/components/alternative-designs/saving-behavior/PlanDesignsMiniTable";
export default {
  name: "RoeChartTableSwitch",
  components: { RoePlanDesignsMiniTable, RoeTooltip },
  data() {
    return {
      chartView: true
    };
  },
  props: {
    name: {
      type: String,
      required: true
    },
    selectingYear: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["lagIndicatorsSelectedYear", "lagIndicatorYears"])
  },
  methods: {
    showChart() {
      this.chartView = true;
    },
    showTable() {
      this.chartView = false;
    },
    ...mapMutations({
      setSelectedYear: ALTERNATIVE_DESIGNS_SET_LAG_INDICATORS_SELECTED_YEAR
    })
  }
};
</script>
